import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login';
import OfficerLogin from './Components/OfficerLogin';
import AdminDashboard from './Components/AdminDashboard';
import WebsiteContents from './Components/WebsiteContents';
import CustomizableForm from './Components/CustomizableForm';
import LMS from './Components/LMS';
import Land from './Components/Land';
import TNSSP from './Components/TNSSP';
import DAP from './Components/DAP';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/officer-login" element={<OfficerLogin />} />
          <Route path="/admin/*" element={<AdminDashboard />}>
            <Route path="website-contents" element={<WebsiteContents />} />
            <Route path="customizable-form" element={<CustomizableForm />} />
            <Route path="lms" element={<LMS />} />
            <Route path="land" element={<Land />} />
            <Route path="tnssp" element={<TNSSP />} />
            <Route path="dap" element={<DAP />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;